import React, {PropTypes, Component} from 'react';
import {Promise} from 'es6-promise';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import InputWithLabel from './InputWithLabel';
import {createAnswer, updateAnswer, editAnswer} from '../modules/Question-Answers';
import {emitEvent} from '../lib/mz';

require('es6-promise').polyfill();

function validateForm(values) {
  return Promise.resolve().then(() => {
    if (!values.content) {
      throw new SubmissionError({
        content: 'You must provide some content ...',
        _error: 'Please provide some content ...',
      });
    }
  });
}

// eslint-disable-next-line react/prefer-stateless-function
class AnswerForm extends Component {
  static propTypes = {
    answer: PropTypes.object,
    initialValues: PropTypes.object,
    isUsersQuestion: PropTypes.bool,
    error: PropTypes.string,
    reset: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    editAnswer: PropTypes.func.isRequired,
    widget: PropTypes.bool.isRequired,
    widgetType: PropTypes.string.isRequired,
  };

  render() {
    const {answer, handleSubmit, submitting, isUsersQuestion, widgetType} = this.props;

    const onCancelClick = () => {
      this.props.editAnswer(answer, false);
    };

    const isEditingAnswer = this.props.initialValues && this.props.initialValues.id;
    const cancelButton = isEditingAnswer ? (
      <button className="tes-btn tes-btn--link tes-btn--sm" onClick={onCancelClick}>
        Cancel
      </button>) : '';
    let newAcceptButtonText = isUsersQuestion ? 'Answer your own question' : 'Post answer';
    let acceptButtonText = isEditingAnswer ? 'Update answer' : newAcceptButtonText;

    if (widgetType === 'comment') {
      newAcceptButtonText = 'Add your own comment';
      acceptButtonText = isEditingAnswer ? 'Update comment' : newAcceptButtonText;
    }

    return (
      <form onSubmit={handleSubmit}>
        <Field name="content" type="textarea" rows="8" placeholder="Write your answer…" hideLabel component={InputWithLabel} label="Feel free to use markdown" />
        <div className="action-buttons">
          <div className="action-buttons__item">
            {cancelButton}
          </div>
          <div className="action-buttons__item action-buttons__item--align-right">
            <button type="submit" className="tes-btn tes-btn--primary tes-btn--sm" disabled={submitting}>
              {acceptButtonText}
            </button>
          </div>
        </div>
      </form>
    );
  }
}

const editableFields = (answer) => (answer ? {
  id: answer.id,
  content: answer.content,
} : null);

const answerFormCreator = (formName) => {
  const ReduxAnswerForm = reduxForm({
    form: formName || 'newAnswer',
  })(AnswerForm);

  const ConnectedAnswer = connect((state, ownProps) => ({
    initialValues: editableFields(ownProps.answer),
  }), (dispatch, ownProps) => ({
    onSubmit: (values) =>
      validateForm(values).then(() => {
        const question = ownProps.question;
        const answer = Object.assign(values, {question_id: question.id});
        emitEvent('SUBMIT', {eventTitle: 'answer'});
        return answer.id ? dispatch(updateAnswer(answer)) : dispatch(createAnswer({answer, question}));
      }),
    editAnswer: (answer, edit) => {
      dispatch(editAnswer(answer, edit));
    },
  }))(ReduxAnswerForm);

  return ConnectedAnswer;
};

export default answerFormCreator;
